import { useState, useCallback } from 'react';

const KEY = 'melodiza:settings';

export const DEFAULTS = {
  theme: 'auto',           // 'light' | 'dark' | 'auto'
  accentColor: '#e8a87c',
  crossfadeDuration: 3,    // seconds
  volumeNormalization: false,
  defaultVolume: 0.8,
  notifications: true,
  business: { name: '', type: 'restaurant', address: '' },
};

export function useSettings() {
  const [settings, setSettings] = useState(() => {
    try {
      const stored = JSON.parse(localStorage.getItem(KEY) || '{}');
      return { ...DEFAULTS, ...stored };
    } catch {
      return DEFAULTS;
    }
  });

  const update = useCallback((patch) => {
    setSettings(prev => {
      const next = { ...prev, ...patch };
      localStorage.setItem(KEY, JSON.stringify(next));
      return next;
    });
  }, []);

  const reset = useCallback(() => {
    setSettings(DEFAULTS);
    localStorage.setItem(KEY, JSON.stringify(DEFAULTS));
  }, []);

  return { settings, update, reset };
}
